module.exports = __webpack_public_path__ + "img/tiktok.4629f309.svg";